<template>
    <div class="logisticsInformation">
        <div class="logisticsInformation-tit">
            <div class="logisticsInformation-tit-l">{{ $t('快递公司') }}</div>
            <div>极兔快递</div>
        </div>

        <div class="logisticsInformation-tit">
            <div class="logisticsInformation-tit-l">{{ $t('快递单号') }}</div>
            <div>6891289749009099008</div>
        </div>

        <div class="after flex">
            <div class="after-l">{{ $t('快物流跟踪') }}</div>
            <div>
                <div class="after-r flex" v-for="(item, index) in list">
                    <div class="after-r-img">
                        <div v-if="index < indexValue" class="after-r-img-box1"></div>
                        <div v-else class="after-r-img-box2"></div>
                        <!-- <img src="../../../assets/icon/circle1.png" alt=""> -->
                        <!-- <img src="../../../assets/icon/circle2.png" alt=""> -->
                    </div>
                    <div class="after-r-box">
                        <div class="after-r-box-tit" :class="index < indexValue ? 'text-61AC85' : ''">{{ item.tit }}
                        </div>
                        <div class="after-r-box-txt">{{ item.time }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'logistics',
    props: {
        list: {
            type: Array,
            required: true,
            default: () => []
        },
        indexValue: {
            type: String,
            required: true,
            default: () => ''
        }
    },
    watch: {

    },
    data() {
        return {

        }
    },
    methods: {

    }
};
</script>

<style scoped lang="scss">
.logisticsInformation {
    /* // padding: 20px; */

    .logisticsInformation-tit {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        font-size: 14px;

        .logisticsInformation-tit-l {
            margin-right: 34px;
            color: #999999;
        }
    }

    .after {
        .after-l {
            font-size: 14px;
            margin-right: 20px;
        }

        .after-r {
            padding-left: 30px;
            border-left: 2px solid #f8f8f8;
            position: relative;

            .after-r-box {
                padding-bottom: 20px;

                .after-r-box-tit {
                    font-size: 14px;
                    margin-bottom: 8px;
                }

                .after-r-box-txt {
                    font-size: 12px;
                    color: #BFBFBF;
                }
            }

            .after-r-img {
                img {
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    left: -7px;
                }

                div {
                    position: absolute;
                    left: -7px;
                    width: 12px;
                    height: 12px;
                    box-sizing: border-box;
                    border-radius: 50%;
                }

                .after-r-img-box1 {
                    border: 4px solid #61AC85;
                    background-color: #FFFFFF;
                }

                .after-r-img-box2 {
                    border: 4px solid #BFBFBF;
                    background-color: #FFFFFF;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/order/components/logistics.vue